import { DocumentRequirementType } from '@wdx/shared/utils';
import { DocumentRequirementWithDocs } from '../../../../state/document-checklist/document-checklist.models';

export type { DocumentRequirementWithDocs };

export interface DocumentChecklistItem {
    documentRequirement: DocumentRequirementWithDocs;
    documentRequirementType: DocumentRequirementType;
}

export enum DocumentChecklistAction {
    AddToEnvelope = 'addtoenvelope',
    Approve = 'approve',
    ApproveWithConditions = 'approvewithconditions',
    Cancel = 'cancel',
    Delete = 'delete',
    Generate = 'generate',
    MarkAsProvided = 'markasprovided',
    Reject = 'reject',
    SendForSignature = 'send',
    Upload = 'receive',
    CreateExternalTask = 'createexternaltask',
}
